export const COUNTRIES = {
  MX: {
    id: "de86d54c-299e-11e6-b67b-9e71128cae77",
    emoji: "🇲🇽",
    unicode: "U+1F1F2 U+1F1FD",
    dialCode: "+52",
    name: "Mexico",
  },
  EC: {
    id: "28242ad8-4cdc-11e5-885d-feff819cdc9f",
    emoji: "🇪🇨",
    unicode: "U+1F1EA U+1F1E8",
    dialCode: "+593",
    name: "Ecuador",
  },
  PE: {
    id: "28242d8a-4cdc-11e5-885d-feff819cdc9f",
    emoji: "🇵🇪",
    unicode: "U+1F1F5 U+1F1EA",
    dialCode: "+51",
    name: "Peru",
  },
  CO: {
    id: "28242ff6-4cdc-11e5-885d-feff819cdc9f",
    emoji: "🇨🇴",
    unicode: "U+1F1E8 U+1F1F4",
    dialCode: "+57",
    name: "Colombia",
  },
  CL: {
    id: "282430f0-4cdc-11e5-885d-feff819cdc9f",
    emoji: "🇨🇱",
    unicode: "U+1F1E8 U+1F1F1",
    dialCode: "+56",
    name: "Chile",
  },
  BO: {
    id: "de86ce4e-299e-11e6-b67b-9e71128cae77",
    emoji: "🇧🇴",
    unicode: "U+1F1E7 U+1F1F4",
    dialCode: "+591",
    name: "Bolivia",
  },
  AR: {
    id: "de86d416-299e-11e6-b67b-9e71128cae77",
    emoji: "🇦🇷",
    unicode: "U+1F1E6 U+1F1F7",
    dialCode: "+54",
    name: "Argentina",
  },
  PA: {
    id: "de86d628-299e-11e6-b67b-9e71128cae77",
    emoji: "🇵🇦",
    unicode: "U+1F1F5 U+1F1E6",
    dialCode: "+507",
    name: "Panama",
  },
  UY: {
    id: "de86d6fa-299e-11e6-b67b-9e71128cae77",
    emoji: "🇺🇾",
    unicode: "U+1F1FA U+1F1FE",
    dialCode: "+598",
    name: "Uruguay",
  },
  PY: {
    id: "de86d7cc-299e-11e6-b67b-9e71128cae77",
    emoji: "🇵🇾",
    unicode: "U+1F1F5 U+1F1FE",
    dialCode: "+595",
    name: "Paraguay",
  },
  VE: {
    id: "de86d88a-299e-11e6-b67b-9e71128cae77",
    emoji: "🇻🇪",
    unicode: "U+1F1FB U+1F1EA",
    dialCode: "+58",
    name: "Venezuela",
  },
  GT: {
    id: "25c35dad-d734-4833-8f59-6fc6eb4e299e",
    emoji: "🇬🇹",
    unicode: "U+1F1EC U+1F1F9",
    dialCode: "+502",
    name: "Guatemala",
  },
  BR: {
    id: "2be26bef-e6d6-4e5d-bf63-7c07579e05c8",
    emoji: "🇧🇷",
    unicode: "U+1F1E7 U+1F1F7",
    dialCode: "+55",
    name: "Brazil",
  },
  ES: {
    id: "30560eff-e6eb-4891-83c5-ca32386e47e1",
    emoji: "🇪🇸",
    unicode: "U+1F1EA U+1F1F8",
    dialCode: "+34",
    name: "España",
  },
  SV: {
    id: "df8974be-ce9b-4d33-8451-af06db27aff4",
    emoji: "🇸🇻",
    unicode: "U+1F1F8 U+1F1FB",
    dialCode: "+503",
    name: "El Salvador",
  },
  DO: {
    id: "7953f64a-2ac3-4da2-a755-480f74755c45",
    emoji: "🇩🇴",
    unicode: "U+1F1E9 U+1F1F4",
    dialCode: "+1",
    name: "Rep Dominicana",
  },
  CR: {
    id: "40d6a090-61ce-4364-97b1-b41ee9e17128",
    emoji: "🇨🇷",
    unicode: "U+1F1E8 U+1F1F7",
    dialCode: "+506",
    name: "Costa Rica",
  },
  HN: {
    id: "f99c4cbf-6f65-4d77-92df-4e0502e1d14b",
    emoji: "🇭🇳",
    unicode: "U+1F1ED U+1F1F3",
    dialCode: "+504",
    name: "Honduras",
  },
  NI: {
    id: "1b919406-549c-11e9-8647-d663bd873d93",
    emoji: "🇳🇮",
    unicode: "U+1F1F3 U+1F1EE",
    dialCode: "+505",
    name: "Nicaragua",
  },
  PR: {
    id: "9909a427-3dd3-4bdd-b2e5-38f3b97c63c9",
    emoji: "🇵🇷",
    unicode: "U+1F1F5 U+1F1F7",
    dialCode: "+1",
    name: "Puerto Rico",
  },
  XX: {
    id: "9c40273c-6b4d-11e7-907b-a6006ad3dba0",
    emoji: "🇺🇸",
    unicode: "U+1F1E8 U+1F1F7",
    dialCode: "+1",
    name: "Other",
  },
  BS: {
    id: "545c1bd7-8865-408b-a6a5-645b160a3020",
    emoji: "🇧🇸",
    unicode: "U+1F1E7 U+1F1F8",
    dialCode: "+1",
    name: "Bahamas",
  }
};

export const COUNTRIES_CODES = Object.entries(COUNTRIES)
  .sort((a, b) => a[1].name.localeCompare(b[1].name))
  .map((country) => ({
    code: country[0],
    dialCode: country[1].dialCode,
    unicode: country[1].unicode,
    id: country[1].id,
  }));
